import styled from 'styled-components';

export const DeliveryStrategySectionStyled = styled.div`
  .deliveryStrategySection {
    &__title {
      display: inline-flex;
      width: 50%;
      padding-bottom: 16px;
      padding-top: 40px;
      font: var(--font-title-400-regular);
      color: var(--color-sonata-primary-800, #162237);
      line-height: 19px;
    };
      
    &__description {
      display: inline-flex;
      width: 50%;
      justify-content: end;
      font: var(--font-body-400-regular);
      color: var(--color-sonata-primary-600, #3D5787);
      line-height: 16px;
    };
      
    &__radios {
      padding-bottom: 16px;
    };
    
    &__check {
      padding-top: 24px;
      
      &Box {
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeM};
        line-height: 19px;
        color: ${props => props.theme.uiColors.textBodyDefault};
      };
        
      &Container {
        display: inline-flex;
        text-wrap: nowrap;
        align-items: center;
        gap: 8px;
        width: 100%;
        padding: 16px;
        margin-top: 16px;
        background: var(--color-sonata-primary-200, #F2F5FC);
        border-radius: 8px;
        font-family: ${props => props.theme.fontRegular};
        font-size: ${props => props.theme.fontSizeXXS};
        line-height: 14px;
        color: ${props => props.theme.uiColors.textBodyDefault};
      }
        
      .customInputContainer {
        margin-top: 0;
        width: auto;
      }
        
      &Input {
        height: 34px;
        width: 72px;
      };
        
      .singleSelectorComponent__control {
        height: 34px;
        min-height: 34px;
        width: 100px;
      }
    }
      
    &__error {
      display: flex;
      align-items: center;
      gap: 8px;
      font-family: ${props => props.theme.fontSemiBold};
      font-size: ${props => props.theme.fontSizeXS};
      color: ${props => props.theme.uiColors.boxError};
      margin-top: 16px;
    };
  }
`;
